import { render, staticRenderFns } from "./NewTemplateCard.vue?vue&type=template&id=0190a110&scoped=true"
import script from "./NewTemplateCard.vue?vue&type=script&lang=js"
export * from "./NewTemplateCard.vue?vue&type=script&lang=js"
import style0 from "./NewTemplateCard.vue?vue&type=style&index=0&id=0190a110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190a110",
  null
  
)

export default component.exports